import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import i18n from '@/plugins/i18n'
import { fetchSpaces } from '@/common/services/SpaceService'
import { removeEntry } from '@/common/services/LocalStorageService'
import localizationServerData from '@/common/services/serverData/localizationServerData'
import { API_CACHE_KEYS } from '@/common/types/cacheConstants'
import { PrefixTranslationsEnum } from '@/common/types/i18n'
import { type SpaceDTOV1 } from '@/common/types/spaces'

const { t } = i18n.global

export const useSpaceStore = defineStore('space', () => {
  const spaces = ref<SpaceDTOV1[]>([])

  const spacesSorted = computed(() => {
    return spaces.value.toSorted((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0))
  })

  const getSpaceLabel = computed(() => {
    return (spaceCode: UUID): string => {
      const space = spaces.value.find((value) => value.code === spaceCode)
      return t(space?.name ?? '')
    }
  })

  async function fetch(invalidate: boolean = false) {
    if (invalidate) {
      removeEntry(API_CACHE_KEYS.SPACES)
      localizationServerData.invalidate(PrefixTranslationsEnum.SPACE)
    }
    ;[spaces.value] = (await fetchSpaces(API_CACHE_KEYS.SPACES)) ?? [] // Fetch only active for the moment (should fetch disabled also)
  }

  return {
    spaces,
    spacesSorted,
    getSpaceLabel,
    fetch,
  }
})
